import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class DbdataService {

  private get apiUrl() { return this.configurations.apiUrl; }

  constructor(
    protected http: HttpClient,
    private configurations: ConfigurationService,
  ) {
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Origin': '*',
      Accept: 'application/json, text/plain, */*'
    })
    // , withCredentials: true,
  };

  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Accept: 'application/json, text/plain, */*'
  });

  httpGetOptions = {
    headers: this.httpHeaders
    // , withCredentials: true,
  };

  getData(pPath: string) {
    try {
      return this.http.get(this.apiUrl + pPath, this.httpGetOptions);
    } catch (error) {
      console.error('getData ' + error);
      return error;
    }
  }

  postData(pPath: string, pData: any) {
    return this.http.post(this.apiUrl + pPath, pData, this.httpOptions);
  }

  getCountries() {
    return this.postData('/Lists/GetCountries', {});
    // .subscribe({
    //   next: data => {
    //       return data;
    //   }
      // , error: error =>{
      //     console.log(error);
      // }
    // });
  }

  getTitles() {
    const mUrl = '/Lists/GetTitles';
    return this.postData(mUrl, {});
  }

  getStatesByCountry(id: string) {
    return this.postData('/Lists/GetStates', { countryCode: id });
      // .subscribe({
      //   next: data => {
      //     // console.log(data);
      //     return data;
      //   },
      //   error: error => {
      //     console.log(error);
      //     return null;
      //   }
      // });
  }

  getProfessionals(pName: string) {
    const mUrl = '/Professional/GetNamesLike?likeName=' + pName + '&maxNames=25&type=1';
    return this.getData(mUrl);
  }

  getIndustries() {
    const mUrl = '/Lists/GetIndustries';
    return this.postData(mUrl, {});
  }

  getSpecialties(pIndustryId: number) {
    const mUrl = '/Lists/GetSpecialties?industryId=-1';
    return this.postData(mUrl, {industryId: pIndustryId});
  }

  getSubSpecialties(pSpecialtyId: number) {
    const mUrl = '/Lists/GetSubSpecialties?specialtyId=-1';
    return this.postData(mUrl, {specialtyId: pSpecialtyId});
  }

  getAddressTypes() {
    const mUrl = '/Lists/GetAddressTypes';
    return this.postData(mUrl, {});
  }

  getPhoneTypes() {
    const mUrl = '/Lists/GetPhoneTypes';
    return this.postData(mUrl, {});
  }

  getProfessionalBusinessAreas() {
    const mUrl = '/Professional/GetProfessionalBusinessAreas';

    return this.postData(mUrl, {});
  }

  addProfessional(pIndustryId: number, pSpecialtyId: number, pSubSpecialtyId: number, pMonthStarted: number, pYearStarted: number) {
    const mUrl = '/Professional/AddProfessionalArea';
    const dataBody = {
      industryId: pIndustryId,
      specialtyId: pSpecialtyId,
      subSpecialtyId: pSubSpecialtyId,
      monthStarted: pMonthStarted,
      yearStarted: pYearStarted
    };

    return this.postData(mUrl, dataBody);
  }

  public getAddressByPostalCode(pCountry: string, postalCode: number) {
    const mUrl = '/Home/GetAddressByPostalCode';
    return this.postData(mUrl, { postal: postalCode, country: pCountry });
  }
}
